import { useEffect, useCallback } from 'react';
import { useOnFunctionCalled } from 'navigation-components/consumer/hooks';
const useOnRealTimeNotification = (componentDef, onNotificationReceived) => {
  const {
    registerCallback
  } = useOnFunctionCalled(componentDef);
  const getNotifications = useCallback(data => {
    onNotificationReceived(data.notification);
  }, [onNotificationReceived]);
  useEffect(() => registerCallback('onNewNotification', getNotifications), [getNotifications, registerCallback]);
};
export default useOnRealTimeNotification;